module.exports = __webpack_public_path__ + "static/media/tj.ae6d1d51.jpg";